import React from 'react';
import PropTypes from 'prop-types';

import { Title, Text, Box } from '@nerdwallet/currency';

import { stringTextAreaSpec, repeatable } from '../../lib/editing-configs';
import parseMdlinks from '../../lib/parse-md-links';

import './terms-table.less';

const TermsTable = ({ title, subtitle, rows }) => {
  const renderedRows = rows.map(
    (
      { left = 'Left cell text here', right = 'Right cell text here' },
      index
    ) => (
      // eslint-disable-next-line react/no-array-index-key
      <Box className="terms-table-row" key={index}>
        <Box className="terms-table-l">
          <Text bold>{parseMdlinks(left)}</Text>
        </Box>
        <Box className="terms-table-r">
          <Text>{parseMdlinks(right)}</Text>
        </Box>
      </Box>
    )
  );

  return (
    <Box className="terms-table__container">
      {title && (
        <Title className="terms-table-title" size="small">
          {title}
        </Title>
      )}
      {subtitle && (
        <Box className="terms-table-subtitle">
          <Text>{subtitle}</Text>
        </Box>
      )}
      <Box className="terms-table">{renderedRows}</Box>
    </Box>
  );
};

TermsTable.defaultProps = {
  rows: [],
};

TermsTable.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      left: PropTypes.string,
      right: PropTypes.string,
    })
  ),
};

TermsTable.getEditingConfig = () => [
  stringTextAreaSpec('title', 'Title'),
  stringTextAreaSpec('subtitle', 'Subtitle'),
  repeatable('rows', 'Term Table Row', 'Row', () => [
    stringTextAreaSpec('left', 'Left side'),
    stringTextAreaSpec('right', 'Right side'),
  ]),
];

TermsTable.displayName = 'TermsTable';

export default TermsTable;
